import { HttpError, get } from "@nhi/utils"
import { INewsletterCard } from "data/contentData/interfaces/mongodb/INewsletter"

/**
 * Endpoint for fething newsletter card data
 * @param path path to determine which newsletter to fetch
 * @returns data for newsletter card
 */
export async function getNewsletter(path: string) {
    const endpoint = `${process.env.NEXT_PUBLIC_CONTENT_API}/Content/NewsletterForPath?path=${path}`

    const { data } = await get<INewsletterCard | null>(
        endpoint,
        undefined
    ).catch((httpError: HttpError) => {
        if (httpError.response?.status == 404) return { data: null }
        else throw httpError
    })
    return data
}
